const DEFAULT_MAIL_TEMPLATE_ID = Number(process.env.VUE_APP_MYPORTAL_MAIL_TEMPLATE_ID) || 8198294
const FALLBACK_RECIPIENT = 'info@fewo-in-ahrenshoop.de'
const BLIND_COPY_RECIPIENT = 'wesselburg@me.com'
const FROM_NAME = 'Fewo in Ahrenshoop'

function parseRecipients(raw) {
  if (!raw) return []
  return String(raw)
    .split(/[;,]/)
    .map((entry) => entry.trim())
    .filter(Boolean)
}

function resolvePrimaryRecipients(mailTo) {
  const fromDb = parseRecipients(mailTo)
  return fromDb.length ? fromDb : [FALLBACK_RECIPIENT]
}

function buildRecipientList(mailTo) {
  const primary = resolvePrimaryRecipients(mailTo)
  return [...new Set([...primary, BLIND_COPY_RECIPIENT])]
}

function sendOneMail(client, recipient, { subject, messageHtml, form, html, text }) {
  if (DEFAULT_MAIL_TEMPLATE_ID > 0) {
    return client.mail.sendMail({
      to: recipient,
      from: 'no-reply@myportal.de',
      fromName: FROM_NAME,
      subject,
      templateId: DEFAULT_MAIL_TEMPLATE_ID,
      templateVariables: {
        subject,
        message: messageHtml,
        reply_email: form.email,
        email: recipient,
        name: form.name,
        phone: form.phone || '',
        callback: 'Nein'
      }
    })
  }

  return client.mail.sendMail({
    to: recipient,
    from: 'no-reply@myportal.de',
    fromName: FROM_NAME,
    subject,
    html,
    text
  })
}

/**
 * Sendet eine Kontaktanfrage per MyPortal Mail-API.
 * Empfänger: contact.email aus der DB (info@…) + Blindkopie an wesselburg@me.com.
 */
export async function sendContactMessage(client, mailTo, form) {
  const recipients = buildRecipientList(mailTo)

  const subject = form.subject
    ? `Kontakt: ${form.subject}`
    : `Kontaktanfrage von ${form.name}`.trim()
  const messageHtml = form.message.replace(/\n/g, '<br>')
  const phoneLine = form.phone ? `<p><strong>Telefon:</strong> ${form.phone}</p>` : ''
  const html = [
    `<p><strong>Name:</strong> ${form.name}</p>`,
    `<p><strong>E-Mail:</strong> ${form.email}</p>`,
    phoneLine,
    form.subject ? `<p><strong>Betreff:</strong> ${form.subject}</p>` : '',
    `<p><strong>Nachricht:</strong></p>`,
    `<p>${messageHtml}</p>`
  ].join('')
  const text = [
    `Name: ${form.name}`,
    `E-Mail: ${form.email}`,
    form.phone ? `Telefon: ${form.phone}` : '',
    form.subject ? `Betreff: ${form.subject}` : '',
    '',
    form.message
  ]
    .filter(Boolean)
    .join('\n')

  await Promise.all(
    recipients.map((recipient) =>
      sendOneMail(client, recipient, { subject, messageHtml, form, html, text })
    )
  )
}
